export enum STORE {
  AUTH = "AUTH",
  PREMIUM = "PREMIUM",
  SEARCH = "SEARCH",
  FILTERING_PARAMS = "FILTERING_PARAMS",
}
export default STORE;
